import { config } from '../config';

const options = {
  primaryNav: '#primary-nav',
  primaryNavList: '#primary-nav-list',
  navLinks: '#primary-nav-list li',
  mobileNavIcon: '.mobile-nav-icon',
  mobileNavIconTs: '.mob-nav-icon',
  navButtons: '.nav-button',
  subNavs: '.nav-level-2',
  activeSubButton: ''
};

const init = () => {

  enquire.register(`screen and (max-width: ${config.breakpoint.mdMax}px)`, {
    match: function() {
      setTimeout( () => {
        createMobileMenu();
      }, 100);
    },
    unmatch: function() {
      destroyMobileMenu();
    }
  });

  enquire.register(`screen and (min-width: ${config.breakpoint.lgMin}px)`, {
    match: function() {
      setTimeout( () => {
        createDesktopMenu();
      }, 100);
    },
    unmatch: function() {
      destroyDesktopMenu();
    }
  });

  createNavigation();

};




const createMobileMenu = () => {

  // console.log('create mobile nav');

  $('.mega-menu').removeAttr('style');

  $(options.navLinks).has('ul').each((index, el) => {

    // create IDs for the heading and content for each accordion item to associate each heading with its content
    let $this = $(el);
    let buttonID = 'mobile-nav-heading-' + index;
    let contentID = 'mobile-nav-accordion-' + index;

    let $heading = $this.find('.mobile-heading:first');
    let $button = $(`<button type="button" id="${buttonID}" class="nav-button" aria-expanded="false" aria-controls="${contentID}">${$heading.html()}<span role="presentation" class="nav-button__icon"></span></button>`);

    // Add a button inside the heading
    $heading.html($button);

    let $mobileNavContent = null;

    $mobileNavContent = $this.find('ul:first');

    $mobileNavContent
      .attr('ID', contentID)
      .attr('aria-labelledby', buttonID)
      .attr('aria-hidden', 'true');

    let $mobileButton = $this.find('button');

    $mobileButton.on('click', function() {

      // if closing an item, also close any other open items
      // console.log($(options.activeSubButton).attr('ID'));

      let state = $(this).attr('aria-expanded') === 'false' ? true : false;
      $(this).attr('aria-expanded', state);

      // add 'is-active' class to the button for styling purposes
      $(this).toggleClass('is-active');

      // update ARIA attribute for the content
      $mobileNavContent.attr('aria-hidden', !state);

      // show/hide the content
      $mobileNavContent.stop().slideToggle();

    });

  });


  if ($(options.primaryNav).length) {

    $(options.primaryNav).attr('aria-hidden', 'true');

    $(options.mobileNavIcon).each((index, el) => {

      let $this = $(el);

      // add ARIA attributes
      $this.attr('aria-controls', $(options.primaryNav).attr('ID'));
      $this.attr('aria-expanded', 'false');

      $this.on('click', (event) => {

        let state = $this.attr('aria-expanded') === 'false' ? true : false;
        $(options.mobileNavIcon).attr('aria-expanded', state);
        $(options.mobileNavIcon).toggleClass('mobile-nav-icon--alt');
        $(options.mobileNavIconTs).toggleClass('mob-nav-icon--alt');
        $(options.primaryNav).attr('aria-hidden', !state);
        $('html').toggleClass('nav-active');

      });

    });

  }
}

const destroyMobileMenu = () => {

  // console.log('destroy mobile nav')

  // remove ARIA attribute on wrapper
  $(options.primaryNav).removeAttr('aria-hidden');

  // unbind click events
  $(options.mobileNavIcon).off('click');

  // unbind click events
  $(options.navButtons).off('click');

  // remove focus handling
  $('.nav-button, .nav-level-1__link, secondary-nav__link').off('focus');

  // remove modal state
  $(options.mobileNavIcon).removeClass('mobile-nav-icon--alt');
  $('html').removeClass('nav-active');

  // remove modal state travelsphere
  $(options.mobileNavIconTs).removeClass('mob-nav-icon--alt');
  $('html').removeClass('nav-active');

  // close any open subnavs
  $('.nav-button.is-active').click();

  // restore focus to elements behind the nav overlay
  $('a').not('#primary-nav a').attr('tabindex','0');
  $('a').not('#primary-nav a').attr('style','cursor:pointer;');

  options.activeSubButton = '';

  $('.nav-level-1__item').each((index, el) => {
    $(el).find('button').contents().unwrap();
    $(el).find('.nav-button__icon').remove();
  });


  $('.nav-level-2, .nav-level-3')
    .removeAttr('aria-labelledby')
    .removeAttr('aria-hidden')
    .removeAttr('ID')
    .removeAttr('style');

};



const createDesktopMenu = () => {

  // console.log('create desktop nav');

  $(options.navLinks).has('.mega-menu').each((index, el) => {

    // create IDs for the heading and content for each accordion item to associate each heading with its content
    let $this = $(el);
    let buttonID = 'desktop-nav-heading-' + index;
    let contentID = 'desktop-nav-accordion-' + index;

    // Add a button inside the <h2>

    let $heading = $this.find('.nav-level-1__heading');

    let $buttonText = $heading.html();

    let $button = $(`<button type="button" id="${buttonID}" class="nav-button" aria-expanded="false" aria-controls="${contentID}">${$buttonText}<span role="presentation" class="nav-button__icon"></span></button>`);

    // Add the button
    $heading.addClass('js-loaded').html($button);

    let $subNav = null;
    $subNav = $this.find('.mega-menu:first');

    $subNav
      .attr('ID', contentID)
      .attr('aria-labelledby', buttonID)
      .attr('aria-hidden', 'true');

  });

  // add click handler for mega-menu close buttons
  $('.js-mega-close').on('click', function() {
     closeDesktopNavItem();
  });


  // add click handler for subnavs
  // prevent default to stop focus event firing, and handle key events seperately
  $('.nav-button').on('mousedown', (event) => {
    //event.preventDefault();
    let $this = $(event.target);

    if($this.hasClass('is-active')) {
      closeDesktopNavItem();
    } else {
      openDesktopNavItem(event.target);
    }
  });

  // add key handlers for buttons
  $('.nav-button').on('keydown', (event) => {

    let $this = $(event.target);
    // console.log('button pressed');

    switch (event.which) {
      // enter key - 13
      // space key - 32
      case 13:
      case 32:
        if($this.hasClass('is-active')) {
          closeDesktopNavItem();
        } else {
          openDesktopNavItem(event.target);
        }

        break;
    }

  });


  // create tab panels for any mega-manus that have them
  createDesktopTabs();

  createStickyNav();

  // bind click event to the document to close any open sub-menus
  $(document).on('click', (event) => {

    // console.log('document clicked');
    event.stopPropagation();

    //check if the clicked area is dropDown or not
    if ($('#primary-nav').has(event.target).length === 0) {
      closeDesktopNavItem();
    }

  });



  // handle closing open subnavs when tabbing through subnavs (doesn't work on mobile/tablet)
  // also handle tabbing out of the mega menu panel onto the page

  $('.nav-button, .nav-level-1__link, a:not(#primary-nav a), button:not(#primary-nav button), input:not(#primary-nav input)').on('focus', (event) => {

    // console.log('tabbing triggered')
    event.preventDefault();

    if (options.activeSubButton) {
      let $el = options.activeSubButton;
      $el.removeClass('is-active');
      $el.attr('aria-expanded', 'false');
      $el.parent().parent().find('.mega-menu').attr('aria-hidden', 'true');
      $el.parent().parent().find('.mega-menu').fadeOut();
      options.activeSubButton = '';

      // reset tabs to default state
      $('.js-tab-button')
        .attr('aria-selected', 'false')
        .removeClass('is-active')
        .attr('tabindex', '-1');

      $('.mega-menu-content-wrapper')
        .attr('aria-hidden', 'true')
        .attr('tabindex', '-1');

      $('.mega-menu').each((index, el) => {

        let $this = $(el);

        // set first button state
        $this.find('.js-tab-button:eq(0)')
          .attr('aria-selected', 'true')
          .addClass('is-active')
          .attr('tabindex', '0');

        // set first tab state
        $this.find('.mega-menu-content-wrapper:eq(0)')
         .attr('aria-hidden', 'false')
         .attr('tabindex', '0');

      });
    }

  });

};


const openDesktopNavItem = (el) => {
  // console.log('open nav item');
  let $el = $(el);
  // console.log($el.attr('ID'));

  // close any open subnavs
  if (options.activeSubButton) {
    closeDesktopNavItem();
  }

  // set timeout to fix IE11 bug
  setTimeout(function() {

    options.activeSubButton = $el;

    $el
      .addClass('is-active')
      .attr('aria-expanded', 'true');


    let $nextMega = $el.parent().parent().find('.mega-menu');

    $nextMega
      .css('height', $nextMega.height() + 'px')
      .attr('aria-hidden', 'false')
      .addClass('mega-active')
      .fadeIn('fast');

    // focus the first tab if there is a tab panel
    if ( $el.next().has('.nav-level-2') ) {
      $el.parent().parent().find('.js-tab-button:first').focus();
    }

  }, 100);


};



const closeDesktopNavItem = () => {
  // console.log('close nav item');

  $(options.activeSubButton)
    .removeClass('is-active')
    .attr('aria-expanded', 'false');

  $(options.activeSubButton).parent().parent().find('.mega-menu')
    .attr('aria-hidden', 'true')
    .removeClass('mega-active')
    .fadeOut('fast');

  $('.mega-menu-content-wrapper').find('h3').removeAttr('tabindex');

  // reset any tabs to default state
  $('.js-tab-button')
    .attr('aria-selected', 'false')
    .removeClass('is-active');

  $('.mega-menu-content-wrapper')
    .attr('aria-hidden', 'true');

  $('.mega-menu').each((index, el) => {

      let $this = $(el);

      // set first button state
      $this.find('.js-tab-button:eq(0)')
        .attr('aria-selected', 'true')
        .addClass('is-active');

      // set first tab state
      $this.find('.mega-menu-content-wrapper:eq(0)')
        .attr('aria-hidden', 'false');

    });


  $(options.activeSubButton).focus();

  options.activeSubButton = '';

};



const createDesktopTabs = () => {
  // console.log('create tab content');

  $('.mega-menu').has('.nav-level-2').each((index, el) => {
    // console.log('create tabs');

    let $tabGroup = $(el);
    $tabGroup.addClass('has-tabs');

    let $tabList = $tabGroup.find('.nav-level-2');
    $tabList.attr('role', 'tablist').attr('aria-orientation', 'vertical');

    let $tabListItems = $tabGroup.find('.nav-level-2 > li');

    let tabGroupID = index;

    $tabListItems.each((index, el) => {

      let $tabListItem = $(el);
      let tabButtonID = 'tab-heading-' + tabGroupID + '-' + index;
      let tabPanelID = 'tab-content-' + tabGroupID + '-' + index;

      let $tabPanel = $tabGroup.find('.mega-menu-content-wrapper:eq(' + index + ')')

      $tabPanel
        .attr('role', 'tabpanel')
        .attr('ID', tabPanelID)
        .attr('aria-labelledby', tabButtonID)
        .attr('aria-hidden', 'true')
        .attr('tabindex', '-1')
        .addClass('js-tab-panel');

      let tabButtonText = $tabListItem.find('span').text();
      let $tabButton = $(`<button type="button" role="tab" id="${tabButtonID}" class="tab-button js-tab-button" aria-selected="false" aria-controls="${tabPanelID}" tabindex="-1">${tabButtonText}</button>`);

      // add the button to the list item
      $tabListItem
        .attr('role', 'presentation')
        .prepend($tabButton);

      // hide the origin text but retain for use on mobile
      $tabListItem
        .find('span')
        .addClass('hidden');

      $tabButton.on('click', function(event) {
        // console.log('tab button clicked');

        let $this = $(event.target);
        event.preventDefault();

        // hide previous active tab panel
        $tabGroup.find('.js-tab-button.is-active')
          .attr('aria-selected', 'false')
          .attr('tabindex', '-1')
          .removeClass('is-active')

        // set active state on current tab
        $this
          .attr('aria-selected', 'true')
          .attr('tabindex', '0')
          .addClass('is-active')
          .focus();

        // hide previous tab panel
        $tabGroup.find('.js-tab-panel:visible')
          .attr('aria-hidden', 'true')
          .attr('tabindex', '-1');

        // show and set active state on current tab panel
        $('#' + tabPanelID)
          .attr('aria-hidden', 'false')
          .attr('tabindex', '0');
        });

    });


    // set first button active state
    let $firstTab = $tabGroup.find('.js-tab-button:first');
    let $lastTab = $tabGroup.find('.js-tab-button:last');

    $firstTab
      .attr('aria-selected', 'true')
      .attr('tabindex', '0')
      .addClass('is-active');


    // set first tab active state
    let $firstTabPanel = $tabGroup.find('.js-tab-panel:first');

    $firstTabPanel
      .attr('aria-hidden', 'false')
      .attr('tabindex', '0');


   // handle keyboard interaction
   // set keydown events on tabList item for navigating tabs with arrow keys

   $('.js-tab-button').on('keydown', (event) => {

    let $tab = $(event.target);
    // console.log('arrow pressed');

    switch (event.which) {
      // arrow up - 38
      case 38:
        if ( $tab.parent().prev().length != 0 ) {
          $tab.parent().prev().find('.js-tab-button').click();
        } else {
          $lastTab.click();
        }
        break;

        // arrow down - 40
        case 40:
          if ( $tab.parent().next().length != 0 ) {
            $tab.parent().next().find('.js-tab-button').click();
          } else {
            $firstTab.click();
          }
          break;

          }
        }
    );

  });

};



const destroyDesktopMenu = () => {
  // console.log('destroy desktop nav');

  $('.nav-button.is-active').click();
  $('html').off('click');

  // unbind click events
  $(options.navButtons).off('click');

  // $('.nav-level-1__item span').removeClass('hidden');
  // $('.nav-button').remove();

  $('.nav-level-1__item').each((index, el) => {
    $(el).find('.nav-button').contents().unwrap();
    $(el).find('.nav-button__icon').remove();
  });

  $('.mega-menu')
    .removeAttr('aria-labelledby')
    .removeAttr('aria-hidden')
    .removeAttr('ID')
    .removeAttr('style')
    .css('z-index', '-1')
    .removeClass('has-tabs');

  // mobile sections
  $('.nav-level-2__item a').removeClass('hidden');

  // remove close button
  $('.js-mega-close').remove();

  destroyDesktopTabs();

};



// destroy desktop tab functionality
const destroyDesktopTabs = () => {
  // console.log('destroy desktop tabs');


  $('.nav-level-2').removeAttr('role');
  $('.nav-level-2__item').removeAttr('role');
  $('.nav-level-2__item span').removeClass('hidden');

  $('.js-tab-button')
    .off('click')
    .remove();

  $('.mega-menu-content-wrapper')
    .removeAttr('role')
    .removeAttr('aria-labelledby')
    .removeAttr('aria-hidden')
    .removeAttr('ID')
    .removeAttr('style')
    .removeAttr('tabindex');

};



// generic functionality
const createNavigation = () => {

  // close mobile menu by pressing escape
  // close mobile search by pressing escape
  // close open submenus on desktop by pressing escape
  // may need a more centralised approach for handling key codes
  $(document).keydown( (event) => {

    // console.log('keydown menu component');

    if (event.which === 27) {

      // console.log('27');

      // if mobile nav is open, close it
      if ( $('html').hasClass('nav-active') ) {
        // close open nav items
        $('.nav-button.is-active').click();
        // close the nav modal
        $('#mobile-nav-icon-2').click();
      }

      // if mobile search is open
      if ( $('html').hasClass('search-active') ) {
        // close the search modal
        $('#mobile-search-icon-2').click();
      }

      // close any open sub-menus on desktop
      closeDesktopNavItem();

      // close country select, if open
      $('.selected-country-button.is-active').click();

    }

  });

};


const createStickyNav = () => {

  if ($('.js-sticky-target').length) {
    // console.log('create sticky nav');

    // grab the initial top offset of the navigation
    let stickyNavTop = $('.js-sticky-target').offset().top;

    // our function that decides weather the navigation bar should have "fixed" css position or not.
    const stickyNav = () => {
      var scrollTop = $(window).scrollTop(); // our current vertical position from the top

      // if we've scrolled more than the navigation, change its position to fixed to stick to top,
      // otherwise change it back to relative
      if (scrollTop > stickyNavTop) {
        $('.js-sticky-target').addClass('sticky-nav');

        // close open mega menus
        closeDesktopNavItem();

        // close country select, if open
        $('.selected-country-button.is-active').click();

      } else {
        $('.js-sticky-target').removeClass('sticky-nav');
      }
    };

    stickyNav();

    // and run it again every time you scroll
    $(window).scroll( () => {
      stickyNav();
    });

  };

};


export { init }